module.exports = __webpack_public_path__ + "static/card-7-0db66230b7e9be32b6b5d666895f32a5.png";